import routerOptions0 from "/builds/uroweb/uroweb-frontend/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@20.19.1_db0@0.3.2_eslint@8.57.1_ioredis@5.6.1_l_xktxifrdfcfd67blxnm2pn4owi/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}